//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    
    data: () => ({
        id:''
    }),
    methods: {
       chooseuser(usertype){
           this.$put('/sys/user/convert/identity?currentUserType='+usertype+'&id='+this.$route.query.id,'',function(res){
               if(res.data==true){
                   this.$message.success('入驻成功!');
                   setTimeout(()=>{
                       this.$router.push({
                            path:'/person/renzheng'
                        })
                   },1000)
               }else{
                   this.$message.error(res.msg);
               }
           },true)
       },
    },
    mounted() {
       
    }
}
